/**
 * The Perks component
 */
import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  Container,
  Row
 } from 'reactstrap';
// import logo from '../../assets/images/myfolie-logo.svg';
import icon_assembly from '../../assets/images/icons/perks/tools.svg'
import icon_shipping from '../../assets/images/icons/perks/fast-delivery.svg'
import icon_production from '../../assets/images/icons/perks/factory.svg'
import icon_design from '../../assets/images/icons/perks/paint-palette-and-brush.svg'



/**
 * Stateless react component to render the About page
 * @param {Object} props the props passed to the page.
 */
const Perks = (props, context) => {
  const perkEntrys = [
    {
      'image': icon_assembly,
      'title': context.t("Delivered ready for assembly"),
      'text': context.t("You can apply the foil immediately without further ado")
    },
    {
      'image': icon_shipping,
      'title': context.t("Express & EU-wide shipping"),
      'text': context.t("You can decide for yourself how fast we ship your foil to all of Europe")
    },
    {
      'image': icon_production,
      'title': context.t("In-House production"),
      'text': context.t("We produce your order in our own production plant")
    },
    {
      'image': icon_design,
      'title': context.t("Your individual Design"),
      'text': context.t("Customize the color, size and design of your foil")
    },
  ]
  return (
    <div className="perks my-2 py-3">
      <Container className="perks__container">
        <h2 className="text-center d-none">{ context.t("benefits") }</h2>
        <Row>
          {perkEntrys.map(perk =>
            <Col xl={3} xs={6} key={perk.title}>
              <div className="text-center semi-small">
                { perk.image &&
                  <div className="perks__imgwrapper mx-auto mb-3">
                    <img src={perk.image} className="img-fluid" alt={ perk.title} title={ perk.title} loading="lazy"/>
                  </div>
                }
                <div>
                  <h3 className="h6">
                    { perk.title }
                  </h3>
                  <p>
                    { perk.text }
                  </p>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
Perks.contextTypes = {
  t: PropTypes.func
}
export default Perks;
